/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

export const DropdownFilter = React.forwardRef((props, ref) => {
  return (
    <a
      ref={ref}
      className="btn text-primary text-hover-primary font-weight-bolder btn-sm p-0"
      onClick={e => {
        e.preventDefault();
        props.onClick(e);
      }}
    >
      {props.children}
    </a>
  );
});
